import axios from 'axios';
import { show, hide, log } from './Utils'

export function saveMatrixSetting(setting) {
    document.cookie = 'collapsible_states=;max-age=0';

    axios.post('/ajax/shoppingcart/save_matrix_toggle', { toggle: setting }, {
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        }
    });
}

export async function updateShoppingcart(element, amount) {
    let qty_changed_by_order_steps = false;
    let ordermatrix;

    const update = {};

    if (element) {
        const { model, color, size, orderSteps, multiple_qty, discounttype, unitprice, unitlistprice, quantity, hasbeenrounded, maxOrderQty} = element.dataset;

        update['model'] = model;
        update['color'] = color;
        update['size'] = size;
        update['order_steps'] = orderSteps;

        update['value'] = amount;

        // Check for max order qty
        if (parseInt(amount) > parseInt(maxOrderQty)) {
            update['value'] = maxOrderQty;
            $(element).val(update['value']);
            alert(lang['MAXIMUM_ORDER_QUANTITY_REACHED_MESSAGE']);
        }

        if (update['value'] != 0 && update['order_steps'] != 0 && (update['order_steps'] !== update['value'])) {
            if ((amount % update['order_steps']) / 100 != 0) {
                qty_changed_by_order_steps = true;
            }

            update['value'] = Math.ceil(update['value'] / update['order_steps']) * update['order_steps'];
        }

        update['value'] *= multiple_qty;

        if (discounttype !== undefined) {
            update['discounttype'] = discounttype;
            update['unitprice'] = unitprice;
            update['unitlistprice'] = unitlistprice;
            update['quantity'] = quantity;
            update['hasbeenrounded'] = hasbeenrounded;

            update['given_discount'] = amount;
        }
    }

    let parent_path = window.location.pathname;
    parent_path = parent_path.substring(parent_path.lastIndexOf('/') +1);
    const { data } = await axios.post('/ajax/shoppingcart/update', {
        update: Object.keys(update).length > 0 ? update : null,
        use_live_prices: (parent_path == 'shoppingcart'),
    }, {
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        }
    });

    if (data.minimal_order_amount_met !== undefined) {
        const { minimal_order_amount_met } = data;
        const checkoutButton = document.querySelector('#submit-shoppingcart');

        if (checkoutButton) {
            const { url } = checkoutButton.dataset;

            if (minimal_order_amount_met) {
                checkoutButton.classList.remove('disabled');
                checkoutButton.attributes.url = url;
            }
            else {
                checkoutButton.classList.add('disabled');
                checkoutButton.attributes.url = '#';
            }
        }
    }

    if (data.models) {
        if (element) {
            const jQueryf = $('input[data-model="' + update['model'] + '"][data-color="' + update['color'] + '"][data-size="' + update['size'] + '"]');
            const f = jQueryf[0];
            const inputElement = element;

            var model_exists = (typeof (data.models[update['model']]) === 'object');
            var style_exists = (model_exists && typeof (data.models[update['model']].colors[update['color']]) === 'object');
            var variant_exists = (style_exists && typeof (data.models[update['model']].colors[update['color']].sizes[update['size']]) === 'object');

            let multiple_qty = 1;
            var qty = 0;
            var model_no_hash = element.dataset.model;
            var cartAddedNotificationElement = $(document).find('#ordermatrix-' + model_no_hash + '-notification');

            $('.cart-added-notification').addClass('hidden');

            if (variant_exists) {
                var backorder_quantity = data.models[update['model']].backorder_quantity;
                var quantity_in_update = data.models[update['model']].colors[update['color']].sizes[update['size']].quantity;
                multiple_qty = data.models[update['model']].colors[update['color']].sizes[update['size']].multiple_qty;

                if (multiple_qty === null) {
                    multiple_qty = data.models[update['model']].multiple_qty;
                }

                if (multiple_qty > 0) {
                    qty = Math.round(quantity_in_update / multiple_qty);
                } else {
                    qty = Math.round(quantity_in_update);
                }
            }

            if (f !== undefined) {
                f.value = ((qty == 0) ? '' : qty);
                jQueryf.val(((qty == 0) ? '' : qty));

                if (typeof data.models[update['model']] !== 'undefined') {
                    updateVariantPrice(update['model'], update['color'], update['size'], data.models[update['model']].colors[update['color']].sizes[update['size']].formatted_unit_price);
                }
            }

            document.querySelectorAll('.style-total-quantity[data-model="' + update['model'] + '"][data-color="' + update['color'] + '"]').forEach(element => {
                element.innerHTML = (data.models[update['model']].colors[update['color']].quantity / multiple_qty);
            });

            if (style_exists) {
                if (element = document.querySelector('.style-total-qty-times-multiple[data-model="' + update['model'] + '"][data-color="' + update['color'] + '"]')) element.innerHTML = (data.models[update['model']].colors[update['color']].quantity);

                document.querySelectorAll('.style-total-unit-price[data-model="' + update['model'] + '"][data-color="' + update['color'] + '"]').forEach(element => {
                    element.innerHTML = (data.models[update['model']].colors[update['color']].formatted_total_unit_price);
                });

                const openOrderlinesInfo = data.models[update['model']].colors[update['color']].open_orderlines_info;

                if (openOrderlinesInfo) {
                    document.querySelectorAll('.open-orderlines-message[data-model="' + update['model'] + '"][data-color="' + update['color'] + '"]').forEach(message => {
                        message.querySelector('span').textContent = openOrderlinesInfo;
                        show(message);
                    });
                }

                if (qty > 0) {
                    cartAddedNotificationElement.removeClass('hidden');
                }

                var update_amount = 0;
                if (data.models[update['model']].colors[update['color']].given_discount_amount != 0) {
                    update_amount = (data.models[update['model']].colors[update['color']].formatted_given_discount_amount).replace(' ', ' -');
                } else {
                    update_amount = data.formatted_zero_price;
                }

                if (element = document.querySelector('.style_given_discount[data-model="' + update['model'] + '"][data-color="' + update['color'] + '"]')) element.innerHTML = (update_amount);
            } else {
                if (element = document.querySelector('.style-total-quantity[data-model="' + update['model'] + '"][data-color="' + update['color'] + '"]')) element.innerHTML = (0);
                if (element = document.querySelector('.style-total-qty-times-multiple[data-model="' + update['model'] + '"][data-color="' + update['color'] + '"]')) element.innerHTML = (0);

                document.querySelectorAll('.style-total-unit-price[data-model="' + update['model'] + '"][data-color="' + update['color'] + '"]').forEach(element => {
                    element.innerHTML = data.formatted_zero_price;
                });
            }

            if (model_exists) {
                qty = data.models[update['model']].quantity;
                qty_incl_prepack_items = data.models[update['model']].quantity_incl_prepack_items;

                let display_qty = qty / multiple_qty;
                if (qty != qty_incl_prepack_items) display_qty += ' (' + qty_incl_prepack_items / multiple_qty + ')';

                let display_qty_units = qty;
                if (display_qty_units != qty_incl_prepack_items) display_qty_units += ' (' + qty_incl_prepack_items + ')';

                let elements = document.querySelectorAll('.shoppingcart-quantity-' + update['model'])
                if (elements) elements.forEach(function (e) { e.innerHTML = (display_qty) })
                if (element = document.querySelector('.shoppingcart-quantity-units-' + update['model'])) element.innerHTML = (display_qty_units);

                if (element = document.querySelector('#shoppingcart-quantity-backorders-' + update['model'])) {
                    element.innerHTML = (backorder_quantity / multiple_qty);
                    if (backorder_quantity / multiple_qty) {
                        show(element.parentNode);
                    } else {
                        hide(element.parentNode);
                    }
                }

                if (element = document.querySelector('.shoppingcart-quantity-backorders-units-' + update['model'])) {
                    // show backorder units only if it differs from quantity; if there is a multiple_qty
                    element.innerHTML = (backorder_quantity);
                    if (backorder_quantity && multiple_qty > 1 ) {
                        show(element.parentNode);
                    } else {
                        hide(element.parentNode);
                    }
                }

                // Row total
                if (element = document.querySelector('.shoppingcart-totalprice-' + update['model'])) element.innerHTML = (data.models[update['model']].formatted_total_unit_price_minus_given_discount_amount);

                element = document.querySelector('.shoppingcart-strikethrough_totalprice-' +  update['model']);
                const formattedTotalNotLiveUnitPrice = data.models[update['model']].formatted_total_not_live_unit_price;
                if (element && formattedTotalNotLiveUnitPrice !== undefined && data.models[update['model']].formatted_total_unit_price_minus_given_discount_amount != formattedTotalNotLiveUnitPrice) {
                    element.innerHTML = formattedTotalNotLiveUnitPrice;
                }

                element = document.querySelector('.prices-' + update['model'] + ' .not_live_unit_price');
                const formattedMinNotLiveUnitPrice = data.models[update['model']].formatted_min_not_live_unit_price;
                if (element && formattedMinNotLiveUnitPrice !== undefined && data.models[update['model']].formatted_min_unit_price != formattedMinNotLiveUnitPrice) {
                    element.innerHTML = formattedMinNotLiveUnitPrice;
                    document.querySelector('.prices-' + update['model'] + ' .min-unit-price').classList.add('live_unit_price');
                } else {
                    document.querySelector('.prices-' + update['model'] + ' .min-unit-price').classList.remove('live_unit_price');
                }

                // Model min/max unit price
                if (element = document.querySelector('p.prices-' + update['model'] + ' .min-unit-price')) element.innerHTML = (data.models[update['model']].formatted_min_unit_price);
                if (element = document.querySelector('p.prices-' + update['model'] + ' .max-unit-price')) element.innerHTML = (data.models[update['model']].formatted_max_unit_price);
            } else {
                if (element = document.querySelector('.shoppingcart-quantity-' + update['model'])) element.innerHTML = (0);
                if (element = document.querySelector('.shoppingcart-totalprice-' + update['model'])) element.innerHTML = (data.formatted_zero_price);

                if (element = document.querySelector('p.prices-' + update['model'] + ' .min-unit-price')) element.innerHTML = (data.formatted_zero_price);
                if (element = document.querySelector('p.prices-' + update['model'] + ' .max-unit-price')) element.innerHTML = (data.formatted_zero_price);
            }

            const discount_field = document.querySelector('.input_discount[data-model="' + update['model'] + '"][data-color="' + update['color'] + '"]');

            if (discount_field) {
                if (!update['discounttype']) {
                    // quantity update, reset discount
                    discount_field.value = (discount_field.setAttribute('data-mindiscount', ''));
                }
            }

            if (data.models[update['model']]) {
                const tiers = data.models[update['model']].tiers;

                if (!$.isEmptyObject(tiers)) {
                    // must loop, because one variantquantity change can affect all others
                    let model = update['model'];
                    let model_data = data.models[model];

                    $.each(model_data.colors, function (color, color_data) {
                        displayActiveModelColorTiers(update['model'], color, tiers);
                        //color_data.sizes.forEach((size, size_data) => {
                        $.each(color_data.sizes, function(size, size_data) {
                            var size_quantity = Math.round(size_data.quantity / model_data.multiple_qty);

                            if (size_quantity == 0) {
                                if (element = document.querySelector('input[data-model="' + model + '"][data-color="' + color + '"][data-size="' + size + '"]')) element.innerHTML = '';
                            } else {
                                if (element = document.querySelector('input[data-model="' + model + '"][data-color="' + color + '"][data-size="' + size + '"]')) element.value = (size_quantity);
                            }

                            updateVariantPriceInfo(model, color, size, size_data);
                        });
                    });
                }
            }

            displayBackorderInfo(jQueryf);

            // Trigger qty changed by order steps popup
            if (qty_changed_by_order_steps && !$.cookie('dont_show_qty_changed_by_order_steps_again')) {
                showQtyChangedByOrderStepsModal();
            }

            // Trigger qty changed by order steps popup
            if (qty_changed_by_order_steps && !$.cookie('dont_show_qty_changed_by_order_steps_again')) {
                showQtyChangedByOrderStepsModal();
            }

            document.dispatchEvent(new CustomEvent('GTMAmountChanged', {
                detail: {
                    inputObject: document.getElementById($(inputElement).attr('id')) // inputobject is a jQuery object, we need a DOM element
                }
            }));
        } else {
            Object.entries(data.models).forEach(([model, model_data]) => {
                var tiers = data.models[model].tiers;

                Object.entries(model_data.colors).forEach(([color, color_data]) => {
                    Object.entries(color_data.sizes).forEach(([size, size_data]) => {
                        var size_quantity = Math.round(size_data.quantity / model_data.multiple_qty);

                        if (size_quantity == 0) {
                            if (element = document.querySelector('input[data-model="' + model + '"][data-color="' + color + '"][data-size="' + size + '"]')) element.innerHTML = '';
                        } else {
                            if (element = document.querySelector('input[data-model="' + model + '"][data-color="' + color + '"][data-size="' + size + '"]')) element.value = (size_quantity);
                        }

                        document.querySelectorAll('.style-total-quantity[data-model="' + model + '"][data-color="' + color + '"]').forEach(element => {
                            element.innerHTML = data.models[model].colors[color].quantity / model_data.multiple_qty;
                        });

                        document.querySelectorAll('.style-total-qty-times-multiple[data-model="' + model + '"][data-color="' + color + '"]').forEach(element => {
                            element.innerHTML = data.models[model].colors[color].quantity;
                        });

                        document.querySelectorAll('.style-total-unit-price[data-model="' + model + '"][data-color="' + color + '"]').forEach(element => {
                            element.innerHTML = data.models[model].colors[color].formatted_total_unit_price;
                        });

                        displayActiveModelColorTiers(model, color, tiers);
                        updateVariantPrice(model, color, size, size_data.formatted_unit_price);
                    });
                });

                let qty = model_data.quantity;
                let multiple_qty = model_data.multiple_qty;
                let qty_incl_prepack_items = model_data.quantity_incl_prepack_items;
                let backorder_quantity = model_data.backorder_quantity;

                let display_qty = qty / multiple_qty;
                if (qty != qty_incl_prepack_items) display_qty += ' (' + qty_incl_prepack_items / multiple_qty + ')';

                let display_qty_units = qty;
                if (display_qty_units != qty_incl_prepack_items) display_qty_units += ' (' + qty_incl_prepack_items + ')';

                let elements = document.querySelectorAll('.shoppingcart-quantity-' + model);

                if (elements) elements.forEach(function (e) { e.innerHTML = (display_qty) })
                if (element = document.querySelector('.shoppingcart-quantity-units-' + model)) element.innerHTML = (display_qty_units);

                if (element = document.querySelector('#shoppingcart-quantity-backorders-' + model)) {
                    element.innerHTML = (backorder_quantity / multiple_qty);
                    if (backorder_quantity / multiple_qty) {
                        show(element.parentNode);
                    } else {
                        hide(element.parentNode);
                    }
                }

                if (element = document.querySelector('#shoppingcart-quantity-backorders-units-' + model)) {
                    // show backorder units only if it differs from quantity; if there is a multiple_qty
                    element.innerHTML = (backorder_quantity);
                    if (backorder_quantity && multiple_qty > 1) {
                        show(element.parentNode);
                    } else {
                        hide(element.parentNode);
                    }
                }

                if (element = document.querySelector('.shoppingcart-totalprice-' + model)) element.innerHTML = (model_data.formatted_total_unit_price_minus_given_discount_amount);

                element = document.querySelector('.shoppingcart-strikethrough_totalprice-' + model);
                const formattedTotalNotLiveUnitPrice = model_data.formatted_total_not_live_unit_price;
                if (element && formattedTotalNotLiveUnitPrice !== undefined && model_data.formatted_total_unit_price_minus_given_discount_amount != formattedTotalNotLiveUnitPrice) {
                    element.innerHTML = formattedTotalNotLiveUnitPrice;
                }

                element = document.querySelector('.prices-' + model + ' .not_live_unit_price');
                const formattedMinNotLiveUnitPrice = model_data.formatted_min_not_live_unit_price;
                if (element && formattedMinNotLiveUnitPrice !== undefined && model_data.formatted_min_unit_price != formattedMinNotLiveUnitPrice) {
                    element.innerHTML = formattedMinNotLiveUnitPrice;
                    document.querySelector('.prices-' + model + ' .min-unit-price').classList.add('live_unit_price');
                } else {
                    document.querySelector('.prices-' + model + ' .min-unit-price').classList.remove('live_unit_price');
                }
            });
        }
    } else {
        if (element = document.querySelector('.input_variant_qty')) element.innerHTML = '';

        if (element = document.querySelector('.style-total-quantity')) element.innerHTML = ('0');
        if (element = document.querySelector('.style-total-unit-price')) element.innerHTML = (data.formatted_total_unit_price);

        if (element = document.querySelector('.model-total-quantity')) element.innerHTML = ('0');
        if (element = document.querySelector('.model-total-unit-price')) element.innerHTML = (data.formatted_total_unit_price);

        document.querySelectorAll('*[data-role=AddedToCartNotification]').forEach(el => {
            el.classList.add('hidden');
        });

        if (update['model'] !== undefined) {
            if (element = document.querySelector('.shoppingcart-quantity-units-' + update['model'])) element.innerHTML = (0);
            if (element = document.querySelector('.shoppingcart-quantity-backorders-' + update['model'])) element.innerHTML = (0);
            if (element = document.querySelector('.shoppingcart-totalprice-' + update['model'])) element.innerHTML = (data.formatted_total_unit_price);
        }

        var f = document.querySelector('input[data-model="' + update['model'] + '"][data-color="' + update['color'] + '"][data-size="' + update['size'] + '"]');

        if (f) {
            f.innerHTML = '';

            document.dispatchEvent(new CustomEvent('GTMAmountChanged', {
                detail: {
                    inputObject: f
                }
            }));
        }

        updateVariantPrice(update['model'], update['color'], update['size'], 'originalFormattedUnitPrice');
    }

    if (data.quantity) {
        show(document.querySelector('.shoppingcart-stats-button'));
    } else {
        hide(document.querySelector('.shoppingcart-stats-button'));
    }

    if (element = document.querySelector('#global-shoppingcart .cart-total-qty')) element.innerHTML = (data.quantity);

    if (element = document.querySelector('#bag-dropdown')) {
        if (data.quantity) {
            element.classList.add('filled');
            element.querySelector('.num-in-bag').innerHTML = ('(' + parseInt(data.quantity) + ')');
        } else {
            element.querySelector('.num-in-bag').innerHTML = ('(0)');
            element.classList.remove('filled');
        }
    }

    if (element = document.querySelector('#global-shoppingcart .cart-total-price')) element.innerHTML = (data.formatted_total_unit_price_minus_given_discount_amount);

    qty = data.quantity;

    let qty_incl_prepack_items = data.quantity_incl_prepack_items;
    if (qty != qty_incl_prepack_items) qty += ' (' + qty_incl_prepack_items + ')';

    if (element = document.querySelector('#shoppingcart-overview-quantity')) element.innerHTML = (qty);
    if (element = document.querySelector('#shoppingcart-overview-total-unit-price')) element.innerHTML = (data.formatted_total_unit_price_minus_discounts);

    if (data.given_discount_amount > 0) {
        document.querySelectorAll('.given_discounts_container').forEach(element => {
            show(element);
        });
    } else {
        document.querySelectorAll('.given_discounts_container').forEach(element => {
            hide(element);
        });

    }
    if (data.shoppingcart_tier_amount > 0) {
        document.querySelectorAll('.shoppingcart_tier_discount_container').forEach(element => {
            show(element);
        });
    } else {
        document.querySelectorAll('.shoppingcart_tier_discount_container').forEach(element => {
            hide(element);
        });
    }

    if (element = document.querySelector('#shoppingcart-overview-subtotal-unit-price')) element.innerHTML = (data.formatted_total_unit_price);
    if (element = document.querySelector('#shoppingcart-overview-total_unit_price_minus_given_discount_amount')) element.innerHTML = (data.formatted_total_unit_price_minus_given_discount_amount);
    if (element = document.querySelector('#shoppingcart-overview-total_unit_price_minus_given_discount_amount_mobile')) element.innerHTML = (data.formatted_total_unit_price_minus_given_discount_amount);

    if (element = document.querySelector('#shoppingcart-overview-discount')) element.innerHTML = (data.formatted_given_discount_amount);

    if (element = document.querySelector('#shoppingcart-tier-overview-discount')) {
        if (data.formatted_shoppingcart_tier_amount !== undefined) {
            element.innerHTML = (data.formatted_shoppingcart_tier_amount);
        } else {
            hide(element);
        }
    }

    if (element = document.querySelector('#global-shoppingcart-tier')) element.innerHTML = (data.shoppingcart_tier_line);

    // if the price has changed compared to the initial price on load, we need a reload of the live prices to continue
    const onloadQuantity = document.querySelector('.shop-overview--basket')?.dataset.initialQuantityOnLoad;
    const currentQuantity = data.quantity;

    if (onloadQuantity && onloadQuantity != currentQuantity) {
        const submitShoppingcart = document.querySelector('#submit-shoppingcart');
        const submitShoppingcartSpan = document.querySelector('#submit-shoppingcart span');

        if (submitShoppingcartSpan) {
            submitShoppingcartSpan.textContent = lang['REFRESH_LIVE_PRICES'];
        }

        if (submitShoppingcart) {
            submitShoppingcart.setAttribute('href', window.location.href);
            submitShoppingcart.setAttribute('data-url', window.location.href);
        }
    }

    const cartNotOrderStylesElement = document.querySelector('#cart_not_order_styles');

    if (cartNotOrderStylesElement) {
        const cart_not_order_styles = document.querySelector('#cart_not_order_styles').dataset.status;

        if (cart_not_order_styles) {
            document.querySelectorAll('.style-row').forEach(element => {
                qty = parseInt(element.querySelector('.style-total-quantity').innerHTML);

                if (cart_not_order_styles == 'hide' && qty < 1) {
                    hide(element);
                } else {
                    show(element);
                }
            });
        }
    }

    if (data.credit_is_reached) {
        hide(document.querySelector('.credit-is-not-reached'));
        if (element = document.querySelector('#submit-shoppingcart')) element.removeAttribute('disabled');
    } else {
        show(document.querySelector('.credit-is-not-reached'));
        if (element = document.querySelector('#submit-shoppingcart')) element.setAttribute('disabled', 'disabled');
    }

    // update backorder info
    if (typeof inputobject === 'undefined') {
        displayBackorderInfo();
    } else {
        show_stock_message();
    }

    if (document.querySelector('#cart_not_order_styles')) {
        const { status } = document.querySelector('#cart_not_order_styles').dataset;

        document.querySelectorAll('.style_row').forEach(element => {
            switch (status) {
                case 'all':
                    show(element);
                break;
                case 'hide_not_ordered_styles':
                    if (parseInt(element.querySelector('.style-total-quantity').innerHTML) < 1) {
                        hide(element);
                    }
                break;
                case 'hide_not_ordered_variants':
                    element.querySelectorAll('.sizes-el').forEach(variantBox => {
                        if (variantBox.querySelector('.input_variant_qty')) {
                            if (variantBox.querySelector('.input_variant_qty').value === '') {
                                hide(variantBox);
                            }
                        }
                    });

                    if (parseInt(element.querySelector('.style-total-quantity').innerHTML) < 1) {
                        hide(element);
                    }
                    break;
            }
        });
    }

    // Order discount message
    if (data.order_discount_message && document.querySelector('.alert.alert-info.order_discount_message')) {
        document.querySelector('.alert.alert-info.order_discount_message span').innerHTML = data.order_discount_message;
    } else if (document.querySelector('.alert.alert-info.order_discount_message')) {
        document.querySelector('.alert.alert-info.order_discount_message').remove();
    }

    // Minimal order amount message
    handleMinimalOrderAmountMessage(data);
}
